import auth from './auth';
import getProfile from './getProfile';
import getDefaultProfile from './getDefaultProfile';
import updateConnectedDevices from './updateConnectedDevices';

const actions = { auth, getProfile, getDefaultProfile, updateConnectedDevices };

export default actions;
